'use client'

import { useRef } from 'react'
import { InformationSquareIcon } from '@navikt/aksel-icons'
import { BodyLong, Link, Modal } from '@navikt/ds-react'
import { LinkButton } from '@/components/link-button/LinkButton'
import { Texts } from '@/texts/getTexts'

export default function InformasjonModal({ t }: { t: Texts['footer'] }) {
    const ref = useRef<HTMLDialogElement>(null)

    return (
        <>
            <LinkButton onClick={() => ref.current?.showModal()}>{t.informasjon}</LinkButton>
            <Modal
                ref={ref}
                closeOnBackdropClick
                header={{
                    heading: t.informasjon,
                    icon: <InformationSquareIcon aria-hidden />,
                }}
            >
                <Modal.Body>
                    <BodyLong spacing>{t.arbeidsgiver.informasjonAvsnitt1}</BodyLong>
                    <BodyLong spacing>
                        {t.arbeidsgiver.aMeldingBefore}
                        <Link
                            href="https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/veiledning/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t.arbeidsgiver.aMeldingLink}
                        </Link>
                        {t.arbeidsgiver.aMeldingAfter}
                    </BodyLong>
                    <BodyLong spacing>{t.arbeidsgiver.informasjonAvsnitt2}</BodyLong>
                    <BodyLong spacing>{t.arbeidsgiver.informasjonAvsnitt3}</BodyLong>
                    <BodyLong spacing>
                        <Link href="/arbeidsgiver/aa-registeret" target="_blank" rel="noopener noreferrer">
                            {t.merInformasjonLink}
                        </Link>
                        .
                    </BodyLong>
                </Modal.Body>
            </Modal>
        </>
    )
}
